module.exports = "/assets/25c8c71085bd45a0cb4a458710df2abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9V.png
// module id = 2304
// module chunks = 0